const AdvertorialProofSlider = () => {
  async function init(sectionId) {
    const sections = [...document.querySelectorAll('.adv-proof')].filter((section) => {
      return !sectionId || section.closest(`#shopify-section-${sectionId}`);
    });

    sections.forEach(async (section) => {
      const Swiper = window.themeCore?.utils?.Swiper;
      const Autoplay = await window.themeCore?.utils?.getExternalUtil?.('swiperAutoplay');

      if (!Swiper) return;

      if (Autoplay) {
        Swiper.use([Autoplay]);
      }

      const slider = section.querySelector('.js-adv-proof-slider');
      if (!slider || slider.classList.contains('swiper-initialized')) return;

      const slidesCount = slider.querySelectorAll('.swiper-slide').length;

      new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 16,
        grabCursor: true,
        loop: slidesCount > 3,

        autoplay: Autoplay
          ? {
              delay: 4000,
              disableOnInteraction: false
            }
          : false,

        pagination: {
          el: slider.querySelector('.swiper-pagination'),
          clickable: true
        },

        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 24,
            loop: slidesCount > 4
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 24,
            loop: slidesCount > 5
          }
        }
      });
    });
  }

  return Object.freeze({ init });
};

const initAdvertorialProof = () => {
  window.themeCore.AdvertorialProofSlider =
    window.themeCore.AdvertorialProofSlider || AdvertorialProofSlider();

  window.themeCore.utils.register(
    window.themeCore.AdvertorialProofSlider,
    'advertorial-proof-slider'
  );
};

if (window.themeCore && window.themeCore.loaded) {
  initAdvertorialProof();
} else {
  document.addEventListener('theme:all:loaded', initAdvertorialProof, { once: true });
}